import { render, staticRenderFns } from "./DomainForm.vue?vue&type=template&id=3c2899c4"
import script from "./DomainForm.vue?vue&type=script&lang=js"
export * from "./DomainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports